import {
    mapGetters,
    mapActions
} from 'vuex';
// import bModal from 'bootstrap-vue/es/components/modal/modal'
import Datepicker from 'vuejs-datepicker';
import DetailCommande from '../../components/DetailCommande/DetailCommande.vue'
import DetailCommandeLetrecoElec from '../../components/DetailCommandeLetrecoElec/DetailCommandeLetrecoElec.vue'
import CalculDate from '../../components/CalculDate'
import {fr} from 'vuejs-datepicker/dist/locale'

export default {
    components: {
      Datepicker,
      DetailCommande,
      DetailCommandeLetrecoElec,
    },
    data() {
        return {
          commandeIdSelect: 0,
          commandeEditeDateLivraison: [],
          commandeEditeDateRemiseEnPoste: [],
          filtres: {
            dateMin: new Date(Date.now()-30*24*60*60*1000).toJSON().slice(0, 10),
            dateMax: new Date().toJSON().slice(0, 10),
            numero: null,
            client: null,
            destinataire: null,
          },
          fr: fr,
          saisieEnCours: 0,
          rechercheEnCours: false,
          expandedRows: [],
        }
    },

    computed: {
        ...mapGetters([
            'commandes',
            'auth',
        ]),

        numero() {
          return this.filtres.numero
        },
        client() {
          return this.filtres.client
        },
        dateMin() {
          return this.filtres.dateMin
        },
        dateMax() {
          return this.filtres.dateMax
        },

    },

    watch: {
      numero() {
        if (this.saisieEnCours > 0) {
          clearTimeout(this.saisieEnCours);
        }
        this.saisieEnCours = setTimeout(this.refresh, 2000)
      },
      client() {
        if (this.saisieEnCours > 0) {
          clearTimeout(this.saisieEnCours);
        }
        this.saisieEnCours = setTimeout(this.refresh, 2000)
      },
      dateMin() {
        this.refresh()
      },
      dateMax() {
        this.refresh()
      },
      'filtres.destinataire'() {
        if (this.saisieEnCours > 0) {
          clearTimeout(this.saisieEnCours);
        }
        this.saisieEnCours = setTimeout(this.refresh, 2000)
      }
    },

    methods: {

        ...mapActions([
            'getCommandes', 'updateCommande', 'getCommande', 'getCommandesExcel'
        ]),
        onCommandeExpediee(event, commande) {
          let commandeExpediee = this.commandes.find(c => commande.id === c.id);
          commandeExpediee.etat = 2;
        },
        onCommandeMiseAJour(event, commande) {
          this.refresh();
        },
        expandRow(indCommande) {
          let index = this.expandedRows.indexOf(indCommande);
          if(index >= 0) {
            this.expandedRows.splice(index, 1);
          } else {
            this.expandedRows.push(indCommande);
          }
        },
        selectionneCommande(id) {
          // var top = 0;
          if (this.commandeIdSelect == id) {
            this.commandeIdSelect = 0;
          } else {
            this.commandeIdSelect = id;
            // var element = this.$refs['ancre'+id];
            // top = element.getBoundingClientRect().top;
          }
          // window.scrollTo(0, top);
        },

        activateEditDateLivraison(commande) {
          commande.old_date_livraison_estimee = commande.date_livraison_estimee
          commande.old_date_remise_en_poste = commande.date_remise_en_poste
          this.commandeEditeDateLivraison.push(commande.id)
        },
        activateEditDateRemiseEnPoste(commande) {
          commande.old_date_livraison_estimee = commande.date_livraison_estimee
          commande.old_date_remise_en_poste = commande.date_remise_en_poste
          this.commandeEditeDateRemiseEnPoste.push(commande.id)
        },
        cancelEditDateLivraison(commande) {
          commande.date_livraison_estimee = commande.old_date_livraison_estimee
          commande.date_remise_en_poste = commande.old_date_remise_en_poste
          this.commandeEditeDateLivraison.splice(this.commandeEditeDateLivraison.indexOf(commande.id),1)
        },
        cancelEditDateRemiseEnPoste(commande) {
          commande.date_remise_en_poste = commande.old_date_remise_en_poste
          commande.date_livraison_estimee = commande.old_date_livraison_estimee
          this.commandeEditeDateRemiseEnPoste.splice(this.commandeEditeDateRemiseEnPoste.indexOf(commande.id),1)
        },
        updateDateLivraison(commande) {
          this.updateCommande(commande).then(() => {
            this.$toasted.show("Date de livraison estimée mise à jour.", {
              icon: {
                  name: 'check-circle',
              },
              theme: "outline",
              position: "bottom-center",
              duration : 2000
            });
          })
          this.commandeEditeDateLivraison.splice(this.commandeEditeDateLivraison.indexOf(commande.id),1)
          this.commandeEditeDateRemiseEnPoste.splice(this.commandeEditeDateRemiseEnPoste.indexOf(commande.id),1)
        },
        debounceUpdateDateLivraison(commande) {
          commande.date_livraison_estimee = this.calculateDateEstimee(commande)
        },
        refresh() {
          this.saisieEnCours = 0;
          this.rechercheEnCours = true;
          this.getCommandes(this.filtres).then((response) => {
            this.rechercheEnCours = false;
          });
        },

        filtreSaisi() {
          this.saisieEnCours = false;
        },
    },

    filters: {
      formatDate(date) {
        if(date) {
          let parsedDate = new Date(Date.parse(date))
          return parsedDate.toLocaleDateString('fr-FR')
        }
        return "-"
      },
      affranchissement(commande) {
        if(commande.categorie_id == 4) {
          return "Electronique"
        }
        let affranchissement = commande.commande_has_groupe_options.find(e => e.groupe_option.groupe.libelle === 'Affranchissement')
        if(affranchissement) {
          return affranchissement.groupe_option.libelle
        } else {
          return "-"
        }
      },
      etatToText(val) {
        switch (val) {
          case 0:
            return "En attente";
          case 1:
            return "En cours";
          case 2:
            return "Expédiée";
          case 3:
            return "Terminée";
          case 4:
            return "Refusée";
          case 10:
            return "Envoi en cours...";
          default:
            return "Erreur";
        }
      }
    },

		mounted() {
			this.refresh();
			// rafraichissement auto si la commande est en cours
			this.interval = setInterval(() => {
				this.commandes.forEach(commande => {
					if (commande.etat == 10) {
						this.getCommande(commande.id).then(response => {
							commande.etat = response.data
						})
					}
				});
			}, 15000);
		},

    beforeDestroy () {
      clearInterval(this.interval)
   },

    created() {
      this.calculateDateEstimee = CalculDate.calculateDateEstimee
    },


}
